/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileUploadErrorType } from 'src/app/models/FileUploadErrorType';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly translate = inject(TranslateService);
  private readonly env = inject(EnvService);

  toasts: any[] = [];
  errorCounter = {};
  maxSize;

  constructor() {
    this.maxSize = this.getMaxUploadSizeText();
  }

  getMaxUploadSizeText() {
    return Number.parseFloat(this.env.environment.maxUploadSize ?? '0') > 0
      ? `(<${this.env.environment.maxUploadSize}MB) `
      : '';
  }

  showFileUploadErrorToast(type: FileUploadErrorType, options: any = {}) {
    this.toasts.push({
      title: this.translate.instant('Error.Upload.Title'),
      desc: this.translate.instant('Error.Upload.' + type, {
        maxSize: this.maxSize,
      }),
      type,
      ...options,
    });
  }

  showErrorToast(err: any, options: any = {}) {
    const type = err.statusCode ?? err.message;
    this.incrementErrorCounter(type);
    const title =
      (err.statusCode ?? this.translate.instant('Error.Default')) +
      this.getErrorCounterDisplay(type);
    const desc = err.message;
    this.toasts.push({ title, desc, type, ...options });
  }

  incrementErrorCounter(type: string) {
    if (type in this.errorCounter) {
      this.closeToastByType(type);
      this.errorCounter[type]++;
    } else this.errorCounter[type] = 0;
  }

  getErrorCounterDisplay(type: string) {
    const counter = this.errorCounter[type];
    return counter === 0 ? '' : ' (' + counter + ')';
  }

  closeToast(toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
    delete this.errorCounter[toast.type];
  }

  closeToastByType(type) {
    this.toasts = this.toasts.filter((toast) => toast.type !== type);
  }

  closeNetworkErrorToast() {
    const networkErrorToast = this.toasts.find(
      (toast) => toast.type === 'Network request failed', // This is actual error message, not translation
    );
    if (networkErrorToast) this.closeToast(networkErrorToast);
  }
}
